import * as betprofessor from './RaceTable.styles.betprofessor';
import * as betroyale from './RaceTable.styles.betroyale';
import * as fiestabet from './RaceTable.styles.fiestabet';
import * as goldenrush from './RaceTable.styles.goldenrush';
import * as juicybet from './RaceTable.styles.juicybet';
import * as puntcity from './RaceTable.styles.puntcity';
import * as puntgenie from './RaceTable.styles.puntgenie';
import * as questbet from './RaceTable.styles.questbet';
import * as sterlingparker from './RaceTable.styles.sterlingparker';
import * as vikingbet from './RaceTable.styles.vikingbet';
import * as volcanobet from './RaceTable.styles.volcanobet';
import * as wellbet from './RaceTable.styles.wellbet';
import * as forsport from './RaceTable.styles.forsport';
import * as junglebet from './RaceTable.styles.junglebet';
import * as sugarcastle from './RaceTable.styles.sugarcastle';
import * as oldgill from './RaceTable.styles.oldgill';
import * as buffalobet from './RaceTable.styles.buffalobet';
import * as betgalaxy from './RaceTable.styles.betgalaxy';
import * as titanbet from './RaceTable.styles.titanbet';
import * as slambet from './RaceTable.styles.slambet';
import * as gigabet from './RaceTable.styles.gigabet';
import * as betstride from './RaceTable.styles.betstride';
import * as templebet from './RaceTable.styles.templebet';
import * as goldenbet888 from './RaceTable.styles.goldenbet888';
import * as hyperbet from './RaceTable.styles.hyperbet';
import * as bet777 from './RaceTable.styles.bet777';
import * as chromabet from './RaceTable.styles.chromabet';
import * as bet575 from './RaceTable.styles.bet575';
import * as betblast from './RaceTable.styles.betblast';
import * as pyramidbet from './RaceTable.styles.pyramidbet';
import * as magnumbet from './RaceTable.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betgalaxy,
  betprofessor,
  betroyale,
  fiestabet,
  goldenrush,
  juicybet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  wellbet,
  forsport,
  junglebet,
  sugarcastle,
  oldgill,
  buffalobet,
  titanbet,
  slambet,
  gigabet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  betblast,
  pyramidbet,
  magnumbet,
};
